import type * as api from '@gitbook/api-client';
import { Icon as FAIcon, type IconName as FAIconName } from '@gitbook/icons';
import { Icon } from '@gitbook/spine-icons';

export function SiteSectionIcon(props: {
    siteSection: api.SiteSection;
    size?: number;
    className?: string;
}) {
    const { siteSection, ...iconProps } = props;
    return siteSection.icon ? (
        <FAIcon icon={siteSection.icon as FAIconName} {...iconProps} />
    ) : (
        <Icon.SiteSection {...iconProps} />
    );
}
